import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import FeedbackWidget from "./FeedbackWidget";

const AppLayout = () => (
  <div className="main-wrapper">
    <Header />
    <Sidebar />
    <Outlet />
    <FeedbackWidget />
  </div>
);

export default AppLayout;
